import { Inject, Injectable, Optional, PLATFORM_ID } from '@angular/core';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { Request } from 'express';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { UserDAO } from '../dao/userDAO';
const appVersion = require('../../../../package.json').version;

@Injectable()
export class DeviceInfoService {
  private readonly userAgent: string;
  private readonly clientVersion = appVersion;
  constructor(
    @Optional() @Inject(REQUEST) private request: Request,
    @Inject(PLATFORM_ID) private platformId: any,
    private readonly userDAO: UserDAO,
  ) {
    if (isPlatformServer(this.platformId)) {
      const userAgentLocal: string | string[] = request.headers['user-agent'];
      if (typeof userAgentLocal !== 'string') {
        // todo - from upgrade - spencer
        // @ts-ignore
        this.userAgent = userAgentLocal.join();
      } else {
        this.userAgent = userAgentLocal;
      }
    } else if (
      isPlatformBrowser(this.platformId) &&
      navigator &&
      navigator.userAgent
    ) {
      this.userAgent = navigator.userAgent;
    } else {
      this.userAgent = 'unknown';
    }
  }

  private getUserAgent(): string {
    return this.userAgent;
  }

  private getCurrentUserId(): number {
    const user = this.userDAO.getCurrentUser();
    if (user && user.id) {
      return user.id;
    } else {
      return null;
    }
  }

  getLoggingInfo(): LoggingInfo {
    return {
      userAgentText: this.getUserAgent(),
      userId: this.getCurrentUserId(),
      applicationVersion: this.clientVersion,
    };
  }
}

export interface LoggingInfo {
  userAgentText: string;
  userId: number;
  applicationVersion: string;
}
